// @flow
import {useEffect} from 'react';
import type {Node} from 'react';
import {Box} from '@wellstone-solutions/web';
import {Outlet} from 'react-router-dom';
import {BridgeEventSources, Events} from '@wellstone-solutions/common';
import {useStores} from 'hooks/useStores';
import {useEventSource} from 'hooks/useEventSource';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {useMembersCounts} from '../queries/useMembersCounts';
import {ListHeader} from './MemberListV2/ListHeader';
import {MembersTabBar} from 'components/MembersTabBar';

const ROLE_PATIENT = ['patient'];

export const MemberRoot = (): Node => {
  const {appUIStore, eventStore} = useStores();

  useEventSource(BridgeEventSources.MEMBERS_PAGE);

  useEffect(() => {
    appUIStore.setBreadcrumbs([]);
    eventStore.addEvent(Events.VIEWED_MEMBER_LIST);
  }, [appUIStore, eventStore]);

  const enableUnassignedUsers = useFeatureFlag(
    LD_FLAGS.ENABLE_UNASSIGNED_USERS,
  );
  const enablePublicInvites = useFeatureFlag(LD_FLAGS.ENABLE_PUBLIC_INVITES);

  const countsQuery = useMembersCounts({role: ROLE_PATIENT});
  const unassignedCount = countsQuery.data?.unassigned ?? 0;

  // Both optional tabs are flag-gated; each appears only when its flag is on.
  const tabs = [
    {path: '/members', label: 'All Members'},
    ...(enableUnassignedUsers
      ? [
          {
            path: '/members/unassigned',
            label: 'Unassigned Members',
            count: unassignedCount,
          },
        ]
      : []),
    ...(enablePublicInvites
      ? [{path: '/members/public-invites', label: 'Public Invites'}]
      : []),
  ];

  return (
    <Box>
      <ListHeader />
      <MembersTabBar tabs={tabs} ariaLabel="Members list tabs" />
      <Outlet />
    </Box>
  );
};
